export default __webpack_public_path__ + "static/media/Y3.20171204.jpg";